import React, { ComponentProps } from "react";

export default function LockIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.8266 5.53516H10.1734C11.9415 5.53516 13.375 6.93706 13.375 8.66615V12.3688C13.375 14.0979 11.9415 15.4998 10.1734 15.4998H3.8266C2.05852 15.4998 0.625 14.0979 0.625 12.3688V8.66615C0.625 6.93706 2.05852 5.53516 3.8266 5.53516ZM6.99619 11.9969C7.36962 11.9969 7.66684 11.7062 7.66684 11.341V9.68646C7.66684 9.32872 7.36962 9.03805 6.99619 9.03805C6.63038 9.03805 6.33316 9.32872 6.33316 9.68646V11.341C6.33316 11.7062 6.63038 11.9969 6.99619 11.9969Z"
        fill="#6C53E8"
      />
      <path
        opacity="0.4"
        d="M11.1415 4.54696V5.65C10.8748 5.57547 10.5928 5.53821 10.3032 5.53821H9.80781V4.54696C9.80781 3.03401 8.55034 1.80427 7.00327 1.80427C5.4562 1.80427 4.19873 3.02656 4.1911 4.53206V5.53821H3.70336C3.40614 5.53821 3.12416 5.57547 2.85742 5.65746V4.54696C2.86504 2.31107 4.71696 0.5 6.98803 0.5C9.28958 0.5 11.1415 2.31107 11.1415 4.54696Z"
        fill="#9E8CFA"
      />
    </svg>
  );
}
